import BoltIcon from "@mui/icons-material/Bolt";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { socialActionBullets, socialActions } from "../data";
import {
  CheckList,
  GradientText,
  Heading,
  IconChip,
  Pill,
  Section,
  tintTextClass,
} from "../shared";

const iconMap = {
  instagram: <InstagramIcon />,
  facebook: <FacebookIcon />,
  x: <XIcon />,
  youtube: <YouTubeIcon />,
  mail: <MailOutlinedIcon />,
};

/**
 * "Viral Social Actions" marketing row. Pairs a stat card of social actions
 * with copy describing post-entry promotion and referral mechanics.
 *
 * @returns {import("react").ReactElement}
 */
export function ViralSocialActions() {
  return (
    <Section className="bg-white">
      <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-14">
        <div className="relative order-2 md:order-1">
          <span
            aria-hidden="true"
            className="bg-cerulean/15 absolute -inset-6 rounded-4xl opacity-70 blur-3xl"
          />
          <div className="shadow-card border-line relative overflow-hidden rounded-[20px] border bg-white p-6 md:p-7">
            <div className="grid grid-cols-2 gap-3">
              {socialActions.map((action) => (
                <div
                  key={action.iconKey}
                  className={`border-line/60 bg-crystal/50 flex flex-col gap-2.5 rounded-2xl border p-4 ${
                    action.wide ? "col-span-2" : ""
                  }`}
                >
                  <IconChip tint={action.tint} size="sm">
                    {iconMap[action.iconKey]}
                  </IconChip>
                  <div className="text-ink-soft text-[13px] font-medium">{action.label}</div>
                  <div className={`text-xl font-bold ${tintTextClass[action.tint]}`}>
                    {action.count}
                  </div>
                </div>
              ))}
            </div>
            <p className="text-muted mt-4 text-center text-[13px] font-medium">
              7,086 extra actions per 1,000 entries (avg.)
            </p>
          </div>
        </div>

        <div className="order-1 flex flex-col items-start md:order-2">
          <Pill variant="eyebrow" icon={<BoltIcon sx={{ fontSize: 14 }} />} className="mb-6">
            Viral Social Actions
          </Pill>
          <Heading as="h3" size="row" className="text-ink mb-5">
            Turn one entry into <GradientText>5-8x more reach.</GradientText>
          </Heading>
          <p className="body-lg text-muted mb-8 max-w-xl">
            Post entry promotion. Send traffic to any offer, link, landing page, or product that you
            choose. Reward extra entries for social follows, referrals, and shares.
          </p>
          <CheckList items={socialActionBullets} />
        </div>
      </div>
    </Section>
  );
}
